
import { ApiManager } from "../api/ApiManager";
import { IDefaultWorkingHoursRequest, IUpdateDefaultWorkingHoursRequest } from "../models/defaultWorkingHours/IDefaultWorkingHoursRequest";
import { IDefaultWorkingHoursResponse } from "../models/defaultWorkingHours/IDefaultWorkingHoursResponse";


export class DefaultWorkingHourActions {
    static fetchDoctorDefaultWorkingHours(params: IDefaultWorkingHoursRequest): Promise<IDefaultWorkingHoursResponse[]> {
        return ApiManager.getOllivanderServiceApis().fetchDoctorDefaultWorkingHours(params);
    }
    static updateDoctorDefaultWorkingHours(params: IUpdateDefaultWorkingHoursRequest[], doctorId: number): Promise<IDefaultWorkingHoursResponse[]> {
        return ApiManager.getOllivanderServiceApis().updateDoctorDefaultWorkingHours(params, doctorId);
    }
}